import { isPlainObject, isString } from 'lodash/fp';

// eslint-disable-next-line no-self-compare
const isNilOrNaN = (x) => x == null || x !== x;

export const isEmpty = (value) =>
    !isNilOrNaN(value) && (Array.isArray(value) || isString(value))
        ? value.length === 0
        : isPlainObject(value)
          ? Object.keys(value).length === 0
          : false;

export const isNotEmpty = (value) => !isEmpty(value);
